import axios from './axiosConfig';
import { useQuery } from '@tanstack/react-query';
import { AgeLevel } from 'types/api/envScales/AgeLevel';
import { AssessmentTemplate } from 'types/api/envScales/AssessmentTemplate';

type ResponseType = {
  assessment_templates: AssessmentTemplate[];
};

// GET /api/v1/assessment_templates
export function getAssessmentTemplates() {
  return axios.get<ResponseType>('/api/v1/assessment_templates');
}

// GET /api/v2/assessment_templates/:id/age_level/:age_level
export function getAgeLevel(assessmentId: number, ageLevel: string) {
  return axios.get<AgeLevel>(
    `/api/v1/assessment_templates/${assessmentId}/age_levels/${ageLevel}`
  );
}

/**
 * The domain/dimension catalog for an age level. Static reference data, so it
 * is pinned as fresh and never refetched within a session.
 */
export function useAgeLevel(templateId?: number, ageLevel?: string) {
  return useQuery({
    queryKey: [
      'envScales',
      'assessment-templates',
      templateId,
      'age-levels',
      ageLevel
    ],
    queryFn: () => getAgeLevel(templateId!, ageLevel!).then(res => res.data),
    enabled: Boolean(templateId && ageLevel),
    staleTime: Infinity
  });
}
